import { clsx } from 'clsx';
import { FC } from 'react';
import { P } from 'atoms/Typography';
import styles from './Discount.module.css';

export const Discount: FC<{
  oldPrice: number;
  currentPrice: number;
  className?: string;
  forMobile?: boolean;
}> = ({ oldPrice, currentPrice, className, forMobile }) => {
  const discount =
    oldPrice && Math.floor(((oldPrice - currentPrice) / oldPrice) * 100);

  return (
    oldPrice !== currentPrice &&
    discount && (
      <P
        className={clsx(className, {
          [styles.root]: !forMobile,
          [styles.badgeMobile]: forMobile,
        })}
      >
        -{discount}%
      </P>
    )
  );
};
